import { render, staticRenderFns } from "./VirtualServerPackage.vue?vue&type=template&id=45bdfd4e&scoped=true&"
import script from "./VirtualServerPackage.vue?vue&type=script&lang=js&"
export * from "./VirtualServerPackage.vue?vue&type=script&lang=js&"
import style0 from "./VirtualServerPackage.vue?vue&type=style&index=0&id=45bdfd4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bdfd4e",
  null
  
)

export default component.exports